module.exports = __webpack_public_path__ + "img/create-video.870ebb85.svg";